import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/contact";
import Services from "../../Services/Services";

export default class Contact extends Page {
  template = templateDefault;

  onLoad(data) {
    super.onLoad(data);

    this.setData({
      "default.page": 4,
    });

    this.addScripts({
      "jquery.min": "assets/js/jquery.min",
      "bootstrap.bundle.min": "assets/js/bootstrap.bundle.min",
      "jquery.hoverIntent.min": "assets/js/jquery.hoverIntent.min",
      "jquery.waypoints.min": "assets/js/jquery.waypoints.min",
      "superfish.min": "assets/js/superfish.min",
      "owl.carousel.min": "assets/js/owl.carousel.min",
      "jquery.plugin.min": "assets/js/jquery.plugin.min",
      "jquery.magnific-popup.min": "assets/js/jquery.magnific-popup.min",
      "jquery.countdown.min": "assets/js/jquery.countdown.min",
      main: "assets/js/main",
      "demo-2": "assets/js/demos/demo-2",
    });

    const uluru = { lat: 37.98196802821208, lng: 23.734202423874724 };

    this.map = new window.google.maps.Map(
      document.getElementById("custom_map"),
      {
        zoom: 18,
        center: uluru,
      }
    );

    var marker = new window.google.maps.Marker({
      position: uluru,
      map: this.map,
    });

    window.google.maps.event.addListener(marker, "click", function () {
      this.map.panTo(this.getPosition());
      this.map.setZoom(19);
    });

    window.scrollTo({
      top: 0,
      left: 0,
    });

    this.setSeoData();
  }

  async setSeoData() {
    const account = this.getHelpers("env").getDefaultAccount();

    const translations = await this.getHelpers("translate").scope({
      account: account,
      app: "content",
      entity: "item",
      entity_slug: "seo",
      scope: "default",
    });

    const description = translations.find(
      (translation) => translation.slug === "default-description"
    ) || { translation: "" };

    const keywords = translations.find(
      (translation) => translation.slug === "default-keywords"
    ) || { translation: "" };

    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", description.translation);

    document
      .querySelector('meta[name="keywords"]')
      .setAttribute("content", keywords.translation);
  }

  sendForm(e) {
    e.preventDefault();

    const message = {};

    message["name"] = document.getElementById("cname").value;
    message["email"] = document.getElementById("cemail").value;
    message["phone"] = document.getElementById("cphone").value;
    message["subject"] = document.getElementById("csubject").value;
    message["message"] = document.getElementById("cmessage").value;

    Services.get("hook").then(async ([Hook]) => {
      const response = await Hook.post("contact-us", message);

      if (response.isValid()) {
        document.getElementById("cname").value = "";
        document.getElementById("cemail").value = "";
        document.getElementById("cphone").value = "";
        document.getElementById("csubject").value = "";
        document.getElementById("cmessage").value = "";
      }
    });

    // Services.get("content").then(([content]) => {
    //   content.contact(message).then(() => {
    //     document.getElementById("cname").value = "";
    //     document.getElementById("cemail").value = "";
    //     document.getElementById("cphone").value = "";
    //     document.getElementById("csubject").value = "";
    //     document.getElementById("cmessage").value = "";
    //   });
    // });

    // if (!error.fields.message) {
    //   Services.get("order", "test").then(([orderService]) => {
    //     orderService
    //       .prepare({ address, business, invoice })
    //       .then(() => {
    //         return orderService.place();
    //       })
    //       .then(() => {
    //         this.redirect("/complete");
    //       })
    //       .catch((err) => {
    //         console.log("error", err);
    //       });
    //   });
    // }
  }

  checkSearch(e) {
    e.preventDefault();
    const devHelper = this.getHelpers("env").getPublicUrl();
    if (document.getElementById("search").value.length > 1) {
      window.location.href =
        devHelper + "/results/" + document.getElementById("search").value;
    }
  }
  checkSearchMobile(e) {
    e.preventDefault();
    const devHelper = this.getHelpers("env").getPublicUrl();
    if (document.getElementById("search_mobile").value.length > 1) {
      window.location.href =
        devHelper +
        "/results/" +
        document.getElementById("search_mobile").value;
    }
  }
}
